export default "__VITE_ASSET__4geJ0yvP__"